"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _SuccessDisplayModule = _interopRequireDefault(require("./SuccessDisplay.module.css"));

var _CustomHR = _interopRequireDefault(require("./CustomHR"));

var _genericValidation = require("../global/utils/genericValidation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Modules
// Styles
// Components
var SuccessDisplay = function SuccessDisplay(props) {
  var _custStyles$container, _custStyles$header, _custStyles$icon, _custStyles$heading, _custStyles$subheadin;

  var children = props.children,
      _props$heading = props.heading,
      heading = _props$heading === void 0 ? 'Success' : _props$heading,
      subHeading = props.subHeading,
      gaEventHandlers = props.gaEventHandlers,
      _props$useHeading = props.useHeading,
      useHeading = _props$useHeading === void 0 ? true : _props$useHeading,
      _props$useHR = props.useHR,
      useHR = _props$useHR === void 0 ? true : _props$useHR,
      custStyles = props.customStylesModuleReference;
  (0, _react.useEffect)(function () {
    if ((0, _genericValidation.isFunction)(gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.load)) gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.load();
    /**
     * We only want this to run once when the component loads
     * so it is safe to ignore the hooks/exhaustive-deps warning
     * eslint-disable-next-line
     */
  }, []);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "".concat(_SuccessDisplayModule.default.container, " ").concat((_custStyles$container = custStyles === null || custStyles === void 0 ? void 0 : custStyles.container) !== null && _custStyles$container !== void 0 ? _custStyles$container : '')
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: "".concat(_SuccessDisplayModule.default.header, " ").concat((_custStyles$header = custStyles === null || custStyles === void 0 ? void 0 : custStyles.header) !== null && _custStyles$header !== void 0 ? _custStyles$header : '')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(_SuccessDisplayModule.default.icon, " ").concat((_custStyles$icon = custStyles === null || custStyles === void 0 ? void 0 : custStyles.icon) !== null && _custStyles$icon !== void 0 ? _custStyles$icon : '')
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: 'check-circle'
  })), useHeading && /*#__PURE__*/_react.default.createElement("h3", {
    className: (_custStyles$heading = custStyles === null || custStyles === void 0 ? void 0 : custStyles.heading) !== null && _custStyles$heading !== void 0 ? _custStyles$heading : ''
  }, heading), subHeading && /*#__PURE__*/_react.default.createElement("h4", {
    className: (_custStyles$subheadin = custStyles === null || custStyles === void 0 ? void 0 : custStyles.subheading) !== null && _custStyles$subheadin !== void 0 ? _custStyles$subheadin : ''
  }, subHeading)), useHR && /*#__PURE__*/_react.default.createElement(_CustomHR.default, null), children);
};

var _default = SuccessDisplay;
exports.default = _default;